import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../routes';
import { MockdLogo } from '../common';

export const Footer: React.FC = () => {

    return (
        <footer className="bg-base-100 border-t border-base-300">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center gap-4 sm:gap-6 text-sm">
                <Link to={ROUTES.home()} className="rounded-field">
                    <MockdLogo size="sm" />
                </Link>
                <nav aria-label="Footer" className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-base-content/80">
                    <a href={ROUTES.docs()} target="_blank" rel="noopener noreferrer" className="link link-hover">Docs</a>
                    <Link to={ROUTES.pricing()} className="link link-hover">Pricing</Link>
                    <Link to={ROUTES.privacy()} className="link link-hover">Privacy</Link>
                    <Link to={ROUTES.terms()} className="link link-hover">Terms</Link>
                </nav>
                <p className="sm:ml-auto text-xs text-base-content/70">© 2026 mockd</p>
            </div>
        </footer>
    );
};
